import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'

import NotFound from './views/not-found'
import Docentes from './views/docentes'
import Modalidades from './views/modalidades'
import Secciones from './views/secciones'
import Main from './views/main'
import Nosotros from './views/nosotros'
import Galeria from './views/galeria'
import Normativa from './views/normativa'

// Portal de Transparencia
import PTHome from './views/portal-transparencia/Home'
import PTInformacionEntidad from './views/portal-transparencia/InformacionEntidad'
import PTNormativa from './views/portal-transparencia/Normativa'
import PTContratacion from './views/portal-transparencia/Contratacion'
import PTPlaneacion from './views/portal-transparencia/Planeacion'
import PTTramites from './views/portal-transparencia/Tramites'
import PTParticipa from './views/portal-transparencia/Participa'
import PTDatosAbiertos from './views/portal-transparencia/DatosAbiertos'
import PTGruposInteres from './views/portal-transparencia/GruposInteres'
import PTInformacionEspecifica from './views/portal-transparencia/InformacionEspecifica'
import PTInformacionTributaria from './views/portal-transparencia/InformacionTributaria'
import PTAdmin from './views/portal-transparencia/Admin'
import PTAdminSetup from './views/portal-transparencia/AdminSetup'
import PTLogin from './views/portal-transparencia/Login'

import './style.css'

const routes = [
    // {
    //   name: '404 - Not Found',
    //   path: '**',
    //   component: NotFound,
    // },
    {
      name: 'Docentes',
      path: '/docentes',
      component: Docentes,
    },
    {
      name: 'Modalidades',
      path: '/modalidades',
      component: Modalidades,
    },
    {
      name: 'Secciones',
      path: '/secciones',
      component: Secciones,
    },
    {
      name: 'Main',
      path: '/',
      component: Main,
    },
    {
      name: 'Nosotros',
      path: '/nosotros',
      component: Nosotros,
    },
    {
      name: 'Galeria',
      path: '/galeria',
      component: Galeria,
    },
    {
      name: 'Normativa',
      path: '/normativa',
      component: Normativa,
    },
    // Portal de Transparencia routes
    {
      name: 'Portal de Transparencia',
      path: '/portal-transparencia',
      component: PTHome,
    },
    {
      name: 'Información de la Entidad',
      path: '/portal-transparencia/informacion-entidad',
      component: PTInformacionEntidad,
    },
    {
      name: 'Normativa PT',
      path: '/portal-transparencia/normativa',
      component: PTNormativa,
    },
    {
      name: 'Contratación',
      path: '/portal-transparencia/contratacion',
      component: PTContratacion,
    },
    {
      name: 'Planeación',
      path: '/portal-transparencia/planeacion',
      component: PTPlaneacion,
    },
    {
      name: 'Trámites',
      path: '/portal-transparencia/tramites',
      component: PTTramites,
    },
    {
      name: 'Participa',
      path: '/portal-transparencia/participa',
      component: PTParticipa,
    },
    {
      name: 'Datos Abiertos',
      path: '/portal-transparencia/datos-abiertos',
      component: PTDatosAbiertos,
    },
    {
      name: 'Grupos de Interés',
      path: '/portal-transparencia/grupos-interes',
      component: PTGruposInteres,
    },
    {
      name: 'Información Específica',
      path: '/portal-transparencia/informacion-especifica',
      component: PTInformacionEspecifica,
    },
    {
      name: 'Información Tributaria',
      path: '/portal-transparencia/informacion-tributaria',
      component: PTInformacionTributaria,
    },
    {
      name: 'Admin Portal',
      path: '/portal-transparencia/admin',
      component: PTAdmin,
    },
    {
      name: 'Admin Setup',
      path: '/portal-transparencia/setup',
      component: PTAdminSetup,
    },
    {
      name: 'Login Portal',
      path: '/portal-transparencia/login',
      component: PTLogin,
    },
  ]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router